module.exports = __webpack_public_path__ + "static/media/CVRUOpenExamForm.d6277bbc.pdf";